<template>
  <!-- Use mouseup.stop to prevent SideLeft/deselectAllSlides function listens to MouseEvent('mouseup'). -->
  <div
    @mouseup.stop
    class="right-panel-container__wrapper"
    :class="{
      'powerpoint-addin': isEnableAddinPowerpoint,
    }"
  >
    <div
      class="right-panel-container"
      v-prevent-wheel-propagation="{ throttleTime: WHEEL_THROTTLE_TIME }"
    >
      <EditPanelHeader
        :showingAudioTab="showingAudioTab"
        :key="`header-${slideActive.id}`"
        v-if="isShowHeaderTabDesign"
      />
      <SettingsPanel v-if="isSettingsContentVisible" :key="`settings-${slideActive.id}`" />
      <div
        v-if="isQuizTeamSetUpVisible"
        class="right-nav-content__quiz-team-set-up
              animate__animated animate__slideInRight animate__faster"
      >
        <PlayAsTeamSetUp @hideMainHeader="togglePlayAsTeamSetUp" />
      </div>
      <div
        class="animation-panel__wrapper
              animate__animated animate__slideInRight animate__faster "
        v-if="isShowAnimationEditor"
        :key="`animation-${slideActive.id}`"
      >
        <ContentSlideAnimationPanel />
      </div>
      <div v-if="isOverlayDisableEditVisible" class="overlay-disable-edit"></div>

      <!-- TAB: AI -->
      <AIEditPanel v-if="isAITabActive" />

      <ContentEditPanel
        v-if="isContentTabActive"
        :showingAudioTab="showingAudioTab"
        :key="`content-${slideActive.id}`"
      />
      <DesignPanelWrapper v-if="isDesignTabActive" :key="`design-${slideActive.id}`" />
      <AudioEditPanel v-if="isAudioTabActive" :key="`audio-${slideActive.id}`" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import EventBus from '@/eventBus'
import { WHEEL_THROTTLE_TIME } from '@/constant/fixedTime'

// components
import SettingsPanel from '@/components-v2/presentation-editor/right-panel-container/SettingsPanel.vue'
import PlayAsTeamSetUp from '@/components-v2/presentation-editor/editor-header/PlayAsTeamSetUp.vue'
import AIEditPanel from '@/components-v2/presentation-editor/side-right/right-nav/AIEditPanel.vue'
import ContentEditPanel from '@/components-v2/presentation-editor/side-right/ContentEditPanel.vue'
import AudioEditPanel from '@/components/presentations/types/AudioEditPanel.vue'
import EditPanelHeader from '@/components-v2/presentation-editor/right-panel-container/EditPanelHeader.vue'
import ContentSlideAnimationPanel from '@/components-v2/presentation-editor/right-panel-container/ContentSlideAnimationPanel.vue'
import DesignPanelWrapper from '@/components-v2/presentation-editor/side-right/right-nav/DesignPanelWrapper.vue'

export default {
  components: {
    SettingsPanel,
    PlayAsTeamSetUp,
    AIEditPanel,
    ContentEditPanel,
    AudioEditPanel,
    EditPanelHeader,
    ContentSlideAnimationPanel,
    DesignPanelWrapper,
  },
  props: {
    showingAudioTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      WHEEL_THROTTLE_TIME,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      canEditPresentation: (state) => state.canEditPresentation,
      selectingBlocks: (state) => state.selectingBlocks,
      isShowAnimationPane: (state) => state.isShowAnimationEditor,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    ...mapGetters('rightNav', ['rightNavTabNames', 'rightNavActiveTab',
      'isAITabActive', 'isContentTabActive', 'isDesignTabActive', 'isAudioTabActive', 'isSettingTabActive']),
    ...mapGetters('rightPanelContainer', ['isSettingsContentVisible', 'isQuizTeamSetUpVisible']),

    isShowHeaderTabDesign() {
      if (this.isDesignTabActive) return false
      return true
    },

    isShowAnimationEditor() {
      const allBlockTypes = ['Image', 'Emoji', 'Shape', 'Line', 'RichText']
      return !!this.selectingBlocks.find((block) => {
        if (allBlockTypes.includes(block.type)) {
          return true
        }
        return false
      }) && this.isShowAnimationPane && this.isContentTabActive
    },

    isOverlayDisableEditVisible() {
      return !this.canEditPresentation && !this.isSettingTabActive && !this.isContentTabActive
    },
  },
  mounted() {
    this.closeQuizTeamSetUpPanelAction()
    this.initWheelScrollAction(this.$el)
  },
  methods: {
    ...mapActions('rightPanelContainer', ['closeQuizTeamSetUpPanelAction']),
    ...mapActions('wheelEvent', ['initWheelScrollAction']),

    togglePlayAsTeamSetUp() {
      EventBus.$emit('EditorHeader: toggle-team-setup')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';
.right-panel-container__wrapper {
  height: 100%;
  &.powerpoint-addin {
  position: fixed;
  right: 98px;
  top: 60px;
  z-index: 1;
  height: calc(100% - 60px);
  overflow-y: auto;
}
}

.right-panel-container {
  @apply rounded-lg my-3 mr-2 border border-base-30 overflow-hidden bg-base-0 relative;
  width: 384px;
  height: calc(100% - 1.5rem);
  box-shadow: 0px 10px 38px 0px #525F7F08;
  transform: scale(1); // to make settings-header fixed and follow this parent
  &.disabled {
    @apply cursor-not-allowed;
  }
}
.right-nav-content__quiz-team-set-up {
  @apply bg-base-0 w-full h-full;
  @apply absolute top-0 right-0 overflow-y-hidden z-20;
  @apply border-l border-base-30;
  animation-duration: 0.3s;
}
.editor-header-tab-container {
}
.animation-panel__wrapper{
  @apply absolute top-0 z-10;
  @apply bg-base-0 w-full;
  @apply right-0 overflow-y-auto z-20;
  @apply h-full fixed;
  border-left: 1px solid #ebebeb;
  animation-duration: 0.3s;
  @media (min-width: 768px) { // md screens
    height: 100%;
    width: 384px;
  }
}
.overlay-disable-edit {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
  z-index: 9;
}

</style>
